module.exports = __webpack_public_path__ + "assets/img/culture_img1.8108f131.png";